import React from 'react';
import Chart from 'react-apexcharts';
import {
  Box,
  Card,
  CardContent,
  Typography,
  useTheme
} from '@material-ui/core';

function CpuUtilization({ classes, data }) {
  const theme = useTheme();

  if (!data || Object.keys(data).length === 0) {
    return null;
  }

  const chartData = {
    options: {
      chart: {
        animations: {
          enabled: true,
          easing: 'easein',
          speed: 120,
          animateGradually: {
            enabled: true,
            delay: 250
          },
          dynamicAnimation: {
            enabled: true,
            speed: 80
          }
        },
        background: theme.palette.background.paper,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: {
            size: '50%'
          },
          track: {
            background: '#e2e2e2',
            strokeWidth: '90%',
            margin: 5
          },
          dataLabels: {
            name: {
              offsetY: 28,
              fontFamily: theme.typography.fontFamily,
              fontSize: 16,
              color: '#111'
            },
            value: {
              offsetY: -20,
              fontSize: 22,
              color: '#111'
            }
          }
        }
      },
      title: {
        text: 'CPU Utilization'
      },
      labels: [' ']
    },
    series: [data.cpuUsage]
  };

  return (
    <Card>
      <Box
        maxWidth={320}
        mx="auto"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <CardContent>
          <Chart
            options={chartData.options}
            series={chartData.series}
            type="radialBar"
            className={classes.chart}
          />
          <Typography align="left" color="textSecondary" variant="body1">
            OS Name: {data['os.name']}
          </Typography>
          <Typography align="left" color="textSecondary" variant="body1">
            Version: {data['os.version']}
          </Typography>
          <Box
            maxWidth={300}
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
          >
            <Typography align="left" color="textSecondary" variant="body1">
              JVM: {data['java.vm.name']} {data['java.version']}
            </Typography>
          </Box>
          <Typography align="left" color="textSecondary" variant="body1">
            Processors: {data['system.processors']}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
}

export default CpuUtilization;
